import { skipToken, useQuery } from "@tanstack/react-query";
import { getHunterUserIDMerchants } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const HUNTER_MERCHANTS_QUERY_KEY = "HUNTER_MERCHANTS";

export const hunterMerchantsKeys = {
  all: [HUNTER_MERCHANTS_QUERY_KEY] as const,
  byUserID: (userID?: number) => [...hunterMerchantsKeys.all, userID] as const,
};

export const useHunterMerchantsQuery = (userID?: number) =>
  useQuery({
    queryKey: hunterMerchantsKeys.byUserID(userID),
    queryFn: userID
      ? processResponseWithApiProblemDetails(() =>
          getHunterUserIDMerchants(userID),
        )
      : skipToken,
  });
